module.exports = import("https://aiadmin-dev.pearson.com/assets/remoteEntry.js");